import { render, staticRenderFns } from "./PrivacyPage.vue?vue&type=template&id=693509b5&scoped=true"
import script from "./PrivacyPage.vue?vue&type=script&lang=ts"
export * from "./PrivacyPage.vue?vue&type=script&lang=ts"
import style0 from "./PrivacyPage.vue?vue&type=style&index=0&id=693509b5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693509b5",
  null
  
)

export default component.exports